import { MessagePerformanceTracker } from './message';
import { PlacementPerformanceTracker } from './placement';

export const UFOv1: {
	MessagePerformanceTracker: typeof MessagePerformanceTracker;
	PlacementPerformanceTracker: typeof PlacementPerformanceTracker;
} = {
	MessagePerformanceTracker,
	PlacementPerformanceTracker,
};
